import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import VueJsonPretty from "vue-json-pretty";


interface Props {
  data: JSON;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VJsonPretty',
  props: {
    data: {}
  },
  setup(__props: any) {

VueJsonPretty.compatConfig = { MODE: 3 };

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VueJsonPretty), {
    class: "json-pretty",
    data: props.data,
    "show-line-number": false,
    "show-icon": ""
  }, null, 8, ["data"]))
}
}

})